import { HighlightCard } from "./Highlights";
import { LiveIndicator } from "./LiveIndicator";

export const Live = ({ events }) => events.map(event =>
    <HighlightCard
        key={event.id}
        backgroundColor={theme => theme.palette.highlights.event_live}
        text="live"
        icon={<LiveIndicator />}
        name={event.name}
        to={`/events/${event.id}`}
    />
);
